"use client"

import { memo, useEffect, useState } from "react"

const BackToTop = () => {
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		const onScroll = () => setVisible(window.scrollY > 500)
		window.addEventListener("scroll", onScroll, { passive: true })
		return () => window.removeEventListener("scroll", onScroll)
	}, [])

	if (!visible) return null

	return (
		<button
			type="button"
			onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
			className="fixed bottom-20 right-4 md:right-8 z-50 w-11 h-11 rounded-full bg-(--brand-primary) text-white shadow-lg flex items-center justify-center text-lg font-bold hover:bg-(--brand-primary-dark) transition-all hover:scale-105"
			aria-label="Back to top"
		>
			↑
		</button>
	)
}

export default memo(BackToTop)
